"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useToast = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_dom_1 = __importDefault(require("react-dom"));
var react_1 = require("react");
var framer_motion_1 = require("framer-motion");
var Toast_1 = require("./Toast");
var PARENT_ELEMENT = null;
var createParentElement = function () {
    if (!PARENT_ELEMENT) {
        var firstScriptElement = document.body.querySelector('script');
        PARENT_ELEMENT = document.getElementById('root-toast');
        PARENT_ELEMENT = document.createElement('div');
        PARENT_ELEMENT.id = 'root-toasts';
        PARENT_ELEMENT.style.cssText = "\n      position: fixed;\n      bottom: 0;\n      right: 0;\n      z-index: 9999;\n    ";
        document.body.insertBefore(PARENT_ELEMENT, firstScriptElement);
    }
    return PARENT_ELEMENT;
};
var getToast = function (toasts, Toast) {
    var _idx = toasts.length - 1;
    var Toasts = [];
    for (var idx = 0; idx < toasts.length; ++idx) {
        var _a = toasts[idx], children = _a.children, id = _a.id, type = _a.type;
        Toasts.push((0, jsx_runtime_1.jsx)(Toast, __assign({ type: type, idx: _idx }, { children: children }), id));
        --_idx;
    }
    return Toasts;
};
var ToastContainer = function (_a) {
    var toasts = _a.toasts, _b = _a.Toast, Toast = _b === void 0 ? Toast_1.Toast : _b;
    var _c = __read((0, react_1.useState)(null), 2), parentElement = _c[0], setElement = _c[1];
    (0, react_1.useEffect)(function () {
        setElement(createParentElement());
    }, []);
    var Toasts = (0, react_1.useMemo)(function () { return getToast(toasts, Toast); }, [toasts.length]);
    return parentElement ? react_dom_1.default.createPortal((0, jsx_runtime_1.jsx)("ul", { children: (0, jsx_runtime_1.jsx)(framer_motion_1.AnimatePresence, { children: Toasts }) }), parentElement) : (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
};
var TIMEOUT_ID = null;
var DEFAULT_CONF = {
    timeout: 7500
};
var useToast = function (_a) {
    var _b = _a === void 0 ? DEFAULT_CONF : _a, timeout = _b.timeout;
    var _c = __read((0, react_1.useState)([]), 2), toasts = _c[0], setToasts = _c[1];
    var handleToastLive = function () {
        if (TIMEOUT_ID)
            return;
        TIMEOUT_ID = setTimeout(function () {
            setToasts([]);
            TIMEOUT_ID = null;
        }, timeout);
    };
    var addToast = function (_a) {
        var children = _a.children, type = _a.type;
        if (toasts.length)
            return;
        setToasts([{ children: children, id: Date.now(), type: type ? type : 'fail' }]);
        handleToastLive();
    };
    return { Container: ToastContainer, addToast: addToast, toasts: toasts };
};
exports.useToast = useToast;
